import { fetchConToken } from '../utils/fetch.ts';

export const getRoles = async (tipo: string = "") => {
  try {
    const resp = await fetchConToken("mantenedores/roles?tipo=" + tipo, {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
};

export const getEstablecimientos = async (comunaId) => {
    try {
      const resp = await fetchConToken("mantenedores/establecimientos?comuna="+comunaId, {}, "GET");
      const body = await resp.json();
      return body;
    }
    catch (error) {
      return { error: true };
    }
};


export const getProgramas= async () => {
  try {
    const resp = await fetchConToken("mantenedores/programas", {}, "GET");
    const body = await resp.json();
    return body;
  }
  catch (error) {
    return { error: true };
  }
};

export const getTipoPasajeros= async () => {
  try {
    const resp = await fetchConToken("mantenedores/tipo-pasajero", {}, "GET");
    const body = await resp.json();
    return body;
  }
  catch (error) {
    return { error: true };
  }
};

export const getTramos= async () => {
  try {
    const resp = await fetchConToken("mantenedores/tramos", {}, "GET");
    const body = await resp.json();
    return body;
  }
  catch (error) {
    return { error: true };
  }
};

export const getRegiones = async () => {
  try {
    const resp = await fetchConToken("mantenedores/regiones", {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
};

export const getComunas = async (region_id: number = 0, comunas_id: string = "", usu_id: number = 0) => {
  try {
    const resp = await fetchConToken("mantenedores/comunas/?region_id=" + region_id +"&comunas_id="+comunas_id+"&usu_id="+usu_id, {}, "GET");
    const body = await resp.json();
    return body;

  } catch (error) {
    return { error: true };
  }
};

export const getComunasAgrupadasRegion = async (region_id: number = 0, comunas_id: string = "", usu_id: number = 0) => {
  try {
    const resp = await fetchConToken("mantenedores/comunas-agrupas-region/?region_id=" + region_id +"&comunas_id="+comunas_id+"&usu_id="+usu_id, {}, "GET");
    const body = await resp.json();
    return body;

  } catch (error) {
    return { error: true };
  }
};


export const getComunasAgrupadasRegionMantenedor = async (region_id: number = 0, comunas_id: string = "", usu_id: number = 0) => {
  try {
    const resp = await fetchConToken("mantenedores/comunas-agrupas-region-mantenedor/?region_id=" + region_id +"&comunas_id="+comunas_id+"&usu_id="+usu_id, {}, "GET");
    const body = await resp.json();
    return body;

  } catch (error) {
    return { error: true };
  }
};




export const enviarGeoJson = async (idfile: number, idtipo: number) => {
  try {
    const resp = await fetchConToken("mantenedores/geojson", { idfile, idtipo }, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
};


export const enviarXlsxIndicadoresManzana = async (idfile: number, anio: number) => {
  try {
    const resp = await fetchConToken("mantenedores/xlsx-indicadores-manzana", { idfile, anio }, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
};


export const enviarXlsxIndicadoresUv = async (idfile: number, anio: number) => {
  try {
    const resp = await fetchConToken("mantenedores/xlsx-indicadores-uv", { idfile, anio }, "POST");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
};


export const descargarArchivo = async (idfile:number, tipo: string) => {
  try {
    
    const resp = await fetchConToken("utils/descargar-archivo", { idfile, tipo }, "POST");
    const body = await resp.blob();
    return body;
  } catch (error) {
    return { error: true };
  }
};


export const getCargaIndicadores = async () => {
  try {
    const resp = await fetchConToken("mantenedores/get-carga-indicadores", {}, "GET");
    const body = await resp.json();
    return body;

  } catch (error) {
    return { error: true };
  }
};



export const getDataDashboard = async () => {
  try {
    const resp = await fetchConToken("mantenedores/get-data-dashboard", {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
};

export const getReporteGiras = async () => {
  try {
    const resp = await fetchConToken("mantenedores/reporte-giras", {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}


export const getNotificaciones = async () => {
  try {
    const resp = await fetchConToken("mantenedores/ultimos-pagos-notificaciones", {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}

export const getGeneros = async () => {
  try {
    const resp = await fetchConToken("mantenedores/generos", {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}

export const tipoAlimentacion = async () => {
  try {
    const resp = await fetchConToken("mantenedores/tipo-alimentacion", {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}

export const tipoSangre = async () => {
  try {
    const resp = await fetchConToken("mantenedores/tipo-sangre", {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}


export const tallaPolera  = async () => {
  try {
    const resp = await fetchConToken("mantenedores/talla-polera", {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    return { error: true };
  }
}


export const getReportePagos = async (fechaInicio: string, fechaFin: string) => {
  try {
    const resp = await fetchConToken("mantenedores/reporte-pagos", { fechaInicio, fechaFin }, "POST");
    const body = await resp.blob();
    return body;
  } catch (error) {
    return { error: true };
  }
}  

export const getReportePagosGetNet = async (fechaInicio: string, fechaFin: string) => {
  try {
    const resp = await fetchConToken("mantenedores/reporte-pagos-getnet", { fechaInicio, fechaFin }, "POST");
    const body = await resp.blob();
    return body;
  } catch (error) {
    return { error: true };
  }
}  


export const getReportePagosTransferencias = async (fechaInicio: string, fechaFin: string) => {
  try {
    const resp = await fetchConToken("mantenedores/reporte-pagos-transferencias", { fechaInicio, fechaFin }, "POST");
    const body = await resp.blob();
    return body;
  } catch (error) {
    return { error: true };
  }
}  

export const getReporteTallas = async (anio: number) => {
  try {
    const resp = await fetchConToken("mantenedores/reporte-tallas", { anio }, "POST");
    const body = await resp.blob();
    return body;
  } catch (error) {
    return { error: true };
  }
}

export const getReporteMenoresEdad = async (idgira: number) => {
  try {
    const resp = await fetchConToken(`mantenedores/reporte-menores-edad`, {idgira}, "POST");
    
    if (!resp.ok) {
      throw new Error('Error al generar el reporte');
    }
    
    const blob = await resp.blob();
    return blob;
  } catch (error) {
    throw error;
  }
};

export default {
  getRoles,
  getRegiones,
  getComunas,
  enviarGeoJson,
  descargarArchivo,
  getNotificaciones,
  getComunasAgrupadasRegionMantenedor,
  getReportePagos,
  getReportePagosGetNet,
  getReporteTallas,
  getReporteMenoresEdad
}